import React from 'react';
import PropTypes from 'prop-types';
import logoExperiencias from 'assets/logo-experiencias.svg';
import { Link } from 'react-router-dom';
import { HashLink as LinkHash } from 'react-router-hash-link';

const Menu = ({ number }) => {
  return (
    <div className="menu-desktop d-none d-lg-block d-xl-block">
      <nav>
        <ul className="container mb-0">
          <li>
            <Link to="/">
              <img className="logo-secondary" src={logoExperiencias} alt="menu-logo" />
            </Link>
          </li>
          <li><LinkHash to="/home/#experiencias">Experiencias</LinkHash></li>
          <li><LinkHash to="/home/#experiencias-recomendadas">Experiencias recomendadas</LinkHash></li>
          <li>
            <Link to="/revive-experiencias">Revive Experiencias</Link>
          </li>
          <li className="icon-shopping-car">
            <Link to="/mis-experiencias" className="position-relative">
              {
                number === 0 ? '' : (
                  <span className="count-header">{number}</span>
                )
              }
              <i className="fas fa-shopping-cart" />
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );
};

Menu.propTypes = {
  number: PropTypes.number.isRequired,
};

export default Menu;
